export default __webpack_public_path__ + "static/media/icone-visualizar-senha-selec.66108628.svg";